<template>
  <div id="wallet-capping-tab" class="position-relative">
    <b-form class="content-body">
      <b-container>
        <b-row>
          <b-col class="h4 font-weight-bold">
            Wallet Capping
            <i
              class="ic-tooltip"
              v-b-popover.hover="
                'Set the transaction and points transfer limits for your customers’ RUSH-powered eWallet.'
              "
            >
            </i>
          </b-col>
        </b-row>
        <capping-fields
          label="Pay"
          field="pay"
          popover-content="Set the transaction limits for your customers’ RUSH-powered eWallet."
        />
        <capping-fields
          label="Topup"
          field="topup"
          popover-content="Set the transaction limits for your customers’ RUSH-powered eWallet."
        />
        <capping-fields
          label="Points Transfer"
          field="transfer"
          popover-content="Set the points transfer limits for your customers’ RUSH-powered eWallet."
        />
      </b-container>
    </b-form>
    <fixed-bottom-container class="text-right">
      <b-button
        variant="primary"
        class="btn-pill"
        size="lg"
        @click="save"
        :disabled="loading"
      >
        Save Changes
      </b-button>
    </fixed-bottom-container>
  </div>
</template>

<script>
import CappingFields from "@/components/wallet/CappingFields.vue";
import FixedBottomContainer from "@/components/common/FixedBottomContainer.vue";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import notification from "@/services/notification";

export default {
  name: "WalletCapping",
  components: {
    CappingFields,
    FixedBottomContainer,
  },
  computed: {
    ...mapState("wallet", [
      "cappingDetails",
      "cappingFieldsToDelete",
      "loading",
    ]),
  },
  validations: {
    cappingDetails: {
      required,
      pay: {
        $each: {
          frequency: {
            required,
          },
        },
      },
      topup: {
        $each: {
          frequency: {
            required,
          },
        },
      },
      transfer: {
        $each: {
          frequency: {
            required,
          },
        },
      },
    },
  },
  methods: {
    getInvalidFeedback(detailsKey, fieldIndex, fieldKey) {
      const field =
        this.$v.cappingDetails[detailsKey].$each[fieldIndex][fieldKey];

      if (field.hasOwnProperty("required") && !field.required)
        return "This field is required.";

      return "";
    },
    validateState(detailsKey, fieldIndex, fieldKey) {
      const { $dirty, $error } =
        this.$v.cappingDetails[detailsKey].$each[fieldIndex][fieldKey];

      return $dirty ? !$error : null;
    },
    getPayload() {
      const payload = JSON.parse(JSON.stringify(this.cappingDetails));

      for (const key in this.cappingDetails) {
        if (this.cappingDetails[key].length) {
          payload[key] = this.cappingDetails[key].map((item) => ({
            ...item,
            limit: item.limit || 0,
          }));
        }
      }

      for (const key in this.cappingFieldsToDelete) {
        if (this.cappingFieldsToDelete[key].length) {
          payload[key] = [...payload[key], ...this.cappingFieldsToDelete[key]];
        }
      }

      return payload;
    },
    async save() {
      this.$v.cappingDetails.$touch();

      if (this.$v.cappingDetails.$invalid)
        notification.warning("Oops, cannot save wallet capping details.");
      else {
        await this.$store.dispatch(
          "wallet/saveCappingDetails",
          this.getPayload()
        );
      }
    },
  },
  async created() {
    await this.$store.dispatch("wallet/getCappingDetails");
  },
};
</script>

<style lang="scss" scoped>
#wallet-capping-tab {
  padding-bottom: 120px;
}
</style>